// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___2L1hx","link":"styles__link___1cFVl"};